<template>
  <div
    class="
      box-border flex h-auto w-full animate-pulse flex-col items-start justify-between rounded-3xl border border-solid
      border-transparent bg-white p-3 !no-underline md:items-center md:p-5
    "
  >
    <div class="mb-5 size-[42px] rounded-full bg-gray-300 md:size-[60px]" />
    <div class="h-3 w-3/4 rounded bg-gray-300 md:h-4" />
  </div>
</template>
